import React from "react";
import {FIELD_TYPE, FORMAT_TIME, tabKeys} from "types/enums";
import {ColumnsType} from "antd/es/table";
import {ColumnProps} from "types/models";
import moment from "moment";
import dayjs from "dayjs";

// import DilateStatusCard from "./DilateStatusCard/DilateStatusCard";
import {listGender} from "data/list";
import {DataFormField} from "types/models/input-field-type";
import {gioiTinhOptions} from "assets/constants/select-catagory-options";
import {parseDatetime, toDateTime} from "helper/format-date";
import {
  convertIosStringToDateDayjs,
  formatDateToString,
  convertDateStringToDateTimezone_7,
} from "helper/common";
const {INPUT, SELECT, DATE, NUMBER} = FIELD_TYPE;

const itemsInputField: DataFormField[] = [
  {
    type: INPUT,
    label: "Mã bệnh nhân",
    name: "maBenhNhan",
    expand: false,
  },
  {
    type: INPUT,
    label: "Tên bệnh nhân",
    name: "tenBenhNhan",
    expand: false,
  },
  {
    type: DATE,
    label: "Ngày sinh",
    name: "ngaySinh",
    expand: false,
  },
  {
    type: INPUT,
    label: "Số điện thoại",
    name: "soDienThoai",
    expand: false,
  },
  {
    type: INPUT,
    label: "Mã phiếu khám",
    name: "maPhieuKham",
    expand: true,
  },
  {
    type: INPUT,
    label: "Địa chỉ",
    name: "diaChi",
    expand: true,
  },
  {
    type: INPUT,
    label: "Số BHYT",
    name: "soTheBaoHiemYTe",
    expand: true,
  },
  {
    type: SELECT,
    label: "Giới tính",
    name: "gioiTinh",
    expand: true,
    options: gioiTinhOptions.filter(it => it.value !== null),
  },
  {
    type: SELECT,
    label: "Trạng thái",
    name: "idTrangThaiNoiTru",
    expand: true,
  },
  {
    type: DATE,
    label: "Từ ngày",
    name: "tuNgay",
    disableDate: false,
    expand: false,
  },
  {
    type: DATE,
    label: "Đến ngày",
    name: "denNgay",
    expand: false,
    disableDate: false,
  },
];

const allColumnsResidential: ColumnProps[] = [
  {
    title: "STT",
    dataIndex: "index",
    show: true,
    isResizable: true,
    render(value, record, index) {
      return <div>{index + 1}</div>;
    },
    align: "center",
  },
  {
    title: "Mã BN",
    dataIndex: "maBenhNhan",
    show: true,
    isResizable: true,
    align: "center",
  },
  {
    title: "Tên BN",
    dataIndex: "tenBenhNhan",
    show: true,
    isResizable: true,
    align: "left",
  },
  {
    title: "Giới tính",
    dataIndex: "gioiTinh",
    show: true,
    isResizable: true,
    align: "left",
    render: (value, record, index) =>
      gioiTinhOptions.find(it => it.value === value)?.label || "",
  },
  {
    title: "Ngày sinh",
    dataIndex: "ngaySinh",
    show: true,
    isResizable: true,
    align: "center",
    width: 150,
    render: (text, record) =>
      text
        ? convertDateStringToDateTimezone_7(text).format(FORMAT_TIME.dayFull)
        : "",
  },
  {
    title: "Số điện thoại",
    dataIndex: "soDienThoai",
    show: true,
    isResizable: true,
    align: "right",
  },
  {
    title: "Thời gian nhập viện",
    dataIndex: "thoiGianNhapVien",
    show: true,
    isResizable: true,
    align: "center",
    width: 150,
    render: (value, record, index) =>
      record.ngayNhapVien ? dayjs(record.ngayNhapVien).format("HH:mm") : "",
  },
  {
    title: "Ngày nhập viện",
    dataIndex: "ngayNhapVien",
    show: true,
    isResizable: true,
    align: "center",
    width: 150,
    render: (value, record, index) =>
      value ? dayjs(value).format("DD/MM/YYYY") : "",
  },
  {
    title: "BS chỉ định",
    dataIndex: "tenBacSiDieuTri",
    show: true,
    isResizable: true,
  },
  {
    title: "Chỉ định",
    dataIndex: "dichVu",
    key: "dichVu",
    show: true,
    isResizable: true,
  },
  {
    title: "Địa chỉ",
    dataIndex: "diaChi",
    show: true,
    isResizable: true,
  },
  {
    title: "Trạng thái",
    dataIndex: "idTrangThaiNoiTru",
    show: true,
    isResizable: true,
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    show: true,
    isResizable: true,
    align: "center",
    width: 100,
    fixed: "right",
  },
];

export {itemsInputField, allColumnsResidential};
